import "./PageHeadlineDetails.css";
import { WebsiteWithUuid } from "../../../../data/website/Website";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
  Tooltip,
  DialogActions,
  TextField,
  Box,
  Typography,
  Snackbar,
  IconButton,
  Grid,
  Avatar,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import PublishIcon from "@mui/icons-material/Publish";
import SaveIcon from "@mui/icons-material/Save";
import PreviewIcon from "@mui/icons-material/Preview";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SettingsBackupRestoreOutlinedIcon from "@mui/icons-material/SettingsBackupRestoreOutlined";
import CloseIcon from "@mui/icons-material/Close";
import UnpublishedOutlinedIcon from "@mui/icons-material/UnpublishedOutlined";
import { createPageEndPointLogic } from "../../../../logic/AssetManagement/PageManagement/CreatePage/createPageEndPointLogic";
import {
  selectUserData,
  setIsLoading,
} from "../../../../features/userSlice";
import { Link, useNavigate } from "react-router-dom";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import store from "../../../../store";
import { useSelector } from "react-redux";
import { Stack } from "@mui/system";
import EditPageModal from "./EditPageModal/EditPageModal";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import LightbulbCircleOutlinedIcon from "@mui/icons-material/LightbulbCircleOutlined";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useDispatch } from "react-redux";
import { formatDate } from "../../../../utils/helpers";

export interface PageHeadlineDetailsProps {
  pageUid: string;
  pageName: string | undefined;
  siteName: string | undefined;
  publishPage: any;
  savePage: any;
  selectedSite: WebsiteWithUuid | null;
  previewLink: string | undefined;
  pageContent: any;
  previewCurrentChange: any;
  siteUid: string;
  oauthTokenHeader: any;
  discardPage: any;
  isPublishOpen: any;
  isElementSaved: any;
  pageContentPageId: any;
  ids: any;
  setPageContent: any;
  setPageDictionary: any;
  setPageUrlContent: any;
  setSiteAllAvailableWidgets: any;
  siteAllAvailableWidgets: any;
  setPageRefreshStatus: any;
  currentPageElements: any;
  currentPageElementsOriginal: any;
  response: any;
  unpublishPage: any;
  matchedSiteName: any;
}

export default function PageHeadlineDetails({
  pageUid,
  publishPage,
  savePage,
  selectedSite,
  previewLink,
  pageContent,
  previewCurrentChange,
  siteUid,
  oauthTokenHeader,
  discardPage,
  isElementSaved,
  setPageRefreshStatus,
  unpublishPage,
  matchedSiteName,
}: PageHeadlineDetailsProps) {
  const navigate = useNavigate();

  const siteURL = selectedSite
    ? Object.values(selectedSite)[0]?.site_url ?? ""
    : "";

  const previewCurrentChangesLink = previewLink ? previewLink : "";
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState("");
  const [iframeWidth, setIframeWidth] = useState(0);
  const [loading, setLoading] = useState(false);
  const iframeHeight = (iframeWidth / 16) * 9;
  const [duplicatePageResponse, setDuplicatePageResponse] = useState([]);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [
    editDuplicatePageConfirmationOpen,
    setEditDuplicatePageConfirmationOpen,
  ] = useState(false);
  const [discardOpen, setdiscardOpen] = useState(false);
  const [unpublishOpen, setUnpublishOpen] = useState(false);
  const postTitle = pageContent?.post_title;
  const postStatus = pageContent?.post_status;
  const [pageTitle, setPageTitle] = useState<string>();
  const [openDuplicateDialogBox, setOpenDuplicateDialogBox] = useState(false);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [duplicateErrorMessage, setDuplicateErrorMessage] = useState("");

  const duplicatePageShareUid = Object.values(duplicatePageResponse)[0];
  const [showDuplicateErrorDialog, setShowDuplicateErrorDialog] =
    useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isDuplicateSuccessful, setIsDuplicateSuccessful] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [, setSelectedPageTitle] = useState<string>(
    pageContent?.post_title || ""
  );
  const [selectedPageStatus, setSelectedPageStatus] = useState<string>(
    pageContent?.post_status || ""
  );
  const duplicateMessage: string = "Page Duplicated Succesfully";
  const userData = useSelector(selectUserData);
  const selectedSiteUid = selectedSite && Object.keys(selectedSite)[0];
  const dispatch = useDispatch();

  const hasEditPagesMetaPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "edit_pages_meta"
  );
  const hasEditPageContentPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "edit_page_content"
  );
  const hasDuplicatePagesPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "duplicate_pages"
  );
  const [openModal, setopenModal] = useState(false);

  const handleOpenModal = () => {
    setopenModal(true);
  };

  const handleCloseModal = () => {
    setopenModal(false);
  };

  useEffect(() => {
    if (pageContent?.post_status) {
      setSelectedPageStatus(pageContent.post_status);
    }
  }, [pageContent?.post_status]);

  const data = {
    data: {
      post_title: `${pageTitle}`,
    },
  };
  const handleClickOpen = async () => {
    setLoading(true);
    setOpen(true);
    await previewCurrentChange();
    setLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVersion("");
    setIframeWidth(0);
    setOpenDialog(false);
  };

  const handleCloseDuplicateDialogBox = () => {
    setOpenDuplicateDialogBox(false);
    setShowDuplicateErrorDialog(false);
  };

  const handleVersionChange = (event: any) => {
    const value = event.target.value;
    setSelectedVersion(value);
  };

  const handleDeviceChange = (event: any) => {
    const value = event.target.value;
    setLoading(true);
    if (value === "1440px") {
      setIframeWidth(1440);
    } else if (value === "768px") {
      setIframeWidth(768);
    } else if (value === "360px") {
      setIframeWidth(414);
    } else {
      setIframeWidth(0);
    }
    setOpen(false);
    setOpenDialog(true);
  };

  const validate = async () => {
    if (!pageTitle) {
      console.error("Missing Mandatory Fields");
    } else {
      try {
        setShowDuplicateErrorDialog(false);
        setDuplicateErrorMessage("");
        setDuplicateLoading(true);
        store.dispatch(setIsLoading(true));
        const success = await duplicatePages();
        if (success) {
          setOpenDuplicateDialogBox(false); // Close the duplicate page dialog ONLY ON SUCCESS
          setSnackbarMessage(
            duplicateMessage ? duplicateMessage : "Page duplicated successfully"
          );
          setShowSuccessPopup(true);
          setIsDuplicateSuccessful(true); // Set state to indicate successful duplication
          setPageRefreshStatus(true);
        } else {
          setIsDuplicateSuccessful(false);
          setShowDuplicateErrorDialog(true);
        }
      } catch (error: any) {
        setShowDuplicateErrorDialog(true); // Show error dialog for duplicate page title
        setDuplicateErrorMessage(error?.message || "An unexpected error occurred");
        setIsDuplicateSuccessful(false);
      } finally {
        setDuplicateLoading(false);
        store.dispatch(setIsLoading(false));
      }
    }
  };



  const handleDuplicateConfirmation = () => {
    setConfirmationOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
    setShowSuccessPopup(false); // Reset showSuccessPopup to false
  };

  const handleDuplicateConfirmationYes = () => {
    setOpenDuplicateDialogBox(true);
    setConfirmationOpen(false);
    setPageTitle(`${postTitle}-copy`);
  };

  const handleDuplicateConfirmationNo = () => {
    setConfirmationOpen(false);
  };
  ////handling the Editduplicate dialouge box

  const handleEditDuplicatePageConfirmation = () => {
    setEditDuplicatePageConfirmationOpen(true);
  };

  const handleEditDuplicatePageConfirmationClose = () => {
    setEditDuplicatePageConfirmationOpen(false);
  };

  const handleEditDuplicatePageConfirmationYes = () => {
    setEditDuplicatePageConfirmationOpen(false);
    setPageRefreshStatus(true);
    navigate(
      `/performance/page_builder/edit?selectedSite=${selectedSiteUid}&selectedPage=${duplicatePageShareUid}`
    );
  };

  const handleEditDuplicatePageConfirmationNo = () => {
    setPageTitle("");
    setEditDuplicatePageConfirmationOpen(false);
  };

  const duplicatePages = async () => {
    try {
      const isSuccess = await createPageEndPointLogic.duplicatePage(
        siteUid,
        data,
        dispatch,
        oauthTokenHeader,
        setDuplicatePageResponse,
        pageUid,
        setShowDuplicateErrorDialog,
        setDuplicateErrorMessage
      );
      if (isSuccess) {
        handleEditDuplicatePageConfirmation();
      }
      return isSuccess;
    } catch (error) {
      console.error("Error fetching page content:", error);
      return false;
    }
  };

  const handleDiscardConfirmation = () => {
    setdiscardOpen(true);
  };

  const handleUnpublishConfirmation = () => setUnpublishOpen(true); //  handleUnpublishConfirmation

  const handlediscardConfirmationClose = () => {
    setdiscardOpen(false);
  };

  const handleunpublishConfirmationClose = () => {
    setUnpublishOpen(false);
  };

  const handleDiscardConfirmationYes = () => {
    if (pageContent?.unpublished_change ? () => discardPage() : undefined) {
      discardPage();
    }
    setdiscardOpen(false);
  };

  const handleUnpublishConfirmationYes = () => {
    if (pageContent?.post_status === "publish") {
      setLoading(false);
      unpublishPage();
      setUnpublishOpen(false);
    }
  };

  const handleDiscardConfirmationNo = () => {
    setdiscardOpen(false);
  };

  // Handle snackbar close
  const handleSnackbarClose = () => {
    setShowSuccessPopup(false);
    // Optionally clear snackbar message state
  };

  // Function to render the snackbar for delete
  const renderSnackbar = () => {
    if (showDuplicateErrorDialog || !isDuplicateSuccessful) {
      return null; // Do not render the snackbar if duplicate error dialog is open or duplication was not successful
    }

    return (
      <Snackbar
        open={showSuccessPopup && isDuplicateSuccessful}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };

  // const [isEditable, setIsEditable] = useState(false);
  const [isEditing] = useState(false);

  useEffect(() => {
    setSelectedPageTitle(pageContent?.post_title || "");
  }, [pageContent]);

  return (
    <>
      {pageContent === undefined ? (
        <SimpleBackdrop />
      ) : (
        <>
          {isDuplicateSuccessful && renderSnackbar()}
          <div className="PageHeadlineDetails5">
            <div className="paper32">
              <div className="PageHeadlineDetails-elements23">
                <div className="PageHeadlineDetailsmedia23">
                  <img
                    className="library-placeholder-image23"
                    alt=""
                    src="/-library--placeholder-image.svg"
                  />
                </div>
                <div className="PageHeadlineDetailsheader-parent4">
                  <div className="PageHeadlineDetailsheader34">
                    <Stack direction="row" gap={2} alignItems="center">
                      {postStatus === "publish" ? (
                        <Link
                          to={`${siteURL}?page_id=${pageContent?.page_id}&nowprocket`}
                          target="_blank"
                          style={{ textDecoration: "underline" }}
                        >
                          <Typography
                            fontSize={24}
                            color="secondary"
                            data-tracker="27"
                            sx={{ textDecoration: "underline" }}
                          >
                            {pageContent?.post_name}
                          </Typography>
                        </Link>
                      ) : (
                        <Typography
                          fontSize={24}
                          data-tracker="27"
                          color="textSecondary"
                          sx={{ textDecoration: "none", cursor: "default" }}
                        >
                          {pageContent?.post_name}
                        </Typography>
                      )}
                      <Alert
                        variant="outlined"
                        icon={
                          selectedPageStatus === "pending" ? (
                            <PendingOutlinedIcon
                              sx={{ color: "#014361", fontSize: "16px" }}
                            />
                          ) : selectedPageStatus === "draft" ? (
                            <LightbulbCircleOutlinedIcon
                              sx={{ color: "#00000099", fontSize: "16px" }}
                            />
                          ) : (
                            <CheckCircleOutlineIcon
                              sx={{ color: "#1E4620", fontSize: "16px" }}
                            />
                          )
                        }
                        sx={{
                          color:
                            selectedPageStatus === "pending"
                              ? "#014361"
                              : selectedPageStatus === "draft"
                              ? "#00000099"
                              : "#1E4620",
                          padding: "4px",
                          border:
                            selectedPageStatus === "pending"
                              ? "1px solid #2196F380"
                              : selectedPageStatus === "draft"
                              ? "1px solid #9E9E9E"
                              : "1px solid #2E7D3280",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "left",
                          textTransform: "capitalize",
                          height: "26px",
                          width: "auto",
                          background:
                            selectedPageStatus === "pending"
                              ? "#E5F6FD"
                              : selectedPageStatus === "draft"
                              ? "#E0E0E0"
                              : "#EDF7ED",
                        }}
                      >
                        {selectedPageStatus}
                      </Alert>
                      <Typography fontWeight={500} color="text.primary">
                        Website:{" "}
                      </Typography>
                      <Typography>{matchedSiteName}</Typography>
                    </Stack>
                  </div>
                  <div className="PageHeadlineDetailsactions42">
                    <div className="button86">
                      <div className="base28">
                        <Tooltip title="Unpublish" placement="top">
                          <IconButton
                            disabled={pageContent?.post_status !== "publish"}
                            onClick={
                              pageContent?.post_status === "publish"
                                ? handleUnpublishConfirmation
                                : undefined
                            }
                          >
                            <UnpublishedOutlinedIcon
                              data-tracker="25"
                              color={
                                pageContent?.post_status === "publish"
                                  ? "secondary"
                                  : "disabled"
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                    <div className="button86">
                      <div className="base28">
                        <Tooltip title="Discard" placement="top">
                          <IconButton
                            disabled={
                              pageContent?.unpublished_change === false ||
                              isEditing
                            }
                          >
                            <SettingsBackupRestoreOutlinedIcon
                              color={
                                pageContent?.unpublished_change && !isEditing
                                  ? "secondary"
                                  : "disabled"
                              }
                              sx={{
                                cursor: pageContent?.unpublished_change
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              data-tracker="23"
                              onClick={handleDiscardConfirmation}
                            />
                          </IconButton>
                        </Tooltip>
                        <Dialog
                          open={discardOpen}
                          onClose={handlediscardConfirmationClose}
                        >
                          <DialogTitle>Confirmation of discard</DialogTitle>
                          <DialogContent>
                            Are you sure you want to discard this change ?
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleDiscardConfirmationNo}
                              color="secondary"
                            >
                              No
                            </Button>
                            <Button
                              onClick={handleDiscardConfirmationYes}
                              color="secondary"
                              variant="contained"
                              data-tracker="24"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Dialog
                          open={unpublishOpen}
                          onClose={handleunpublishConfirmationClose}
                        >
                          <DialogTitle>Confirmation of unpublish</DialogTitle>
                          <DialogContent>
                            Are you sure you want to unpublish this page ?
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleunpublishConfirmationClose}
                              color="secondary"
                            >
                              No
                            </Button>
                            <Button
                              onClick={handleUnpublishConfirmationYes}
                              color="secondary"
                              variant="contained"
                              data-tracker="26"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </div>
                    </div>
                    <div className="button86">
                      <div className="base28">
                        {hasDuplicatePagesPermission ? (
                          <Tooltip title="Duplicate" placement="top">
                            {postStatus === "pending" ? (
                              <IconButton disabled={isEditing}>
                                <ContentCopyIcon
                                  data-tracker="21"
                                  sx={{ cursor: "not-allowed" }}
                                />
                              </IconButton>
                            ) : (
                              <IconButton disabled={isEditing}>
                                <ContentCopyIcon
                                  data-tracker="21"
                                  color={isEditing ? "disabled" : "secondary"}
                                  sx={{ cursor: "pointer" }}
                                  onClick={handleDuplicateConfirmation}
                                />
                              </IconButton>
                            )}
                          </Tooltip>
                        ) : (
                          <ContentCopyIcon color="disabled" data-tracker="21" />
                        )}
                        <Dialog
                          open={confirmationOpen}
                          onClose={handleConfirmationClose}
                        >
                          <DialogTitle>Confirmation of duplicate</DialogTitle>
                          <DialogContent>
                            Are you sure you want to duplicate this page?
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleDuplicateConfirmationNo}
                              color="secondary"
                            >
                              No
                            </Button>
                            <Button
                              onClick={handleDuplicateConfirmationYes}
                              color="secondary"
                              variant="contained"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Dialog
                          open={
                            editDuplicatePageConfirmationOpen &&
                            isDuplicateSuccessful &&
                            !showDuplicateErrorDialog
                          }
                          onClose={handleEditDuplicatePageConfirmationClose}
                        >
                          <DialogTitle>Confirmation of Editing</DialogTitle>
                          <DialogContent>
                            Do you want to edit the duplicate page?
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleEditDuplicatePageConfirmationNo}
                              color="secondary"
                            >
                              No
                            </Button>
                            <Button
                              onClick={handleEditDuplicatePageConfirmationYes}
                              color="secondary"
                              variant="contained"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </div>
                    </div>
                    <Dialog
                      open={openDuplicateDialogBox}
                      fullWidth
                      maxWidth="md"
                    >
                      <div
                        style={{
                          padding: "20px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
                          Duplicate Page
                        </DialogTitle>
                        <div
                          style={{
                            marginBottom: "20px",
                            display: "flex",
                            gap: "20px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <TextField
                              required
                              fullWidth
                              id="pageTitle"
                              label="Page Title"
                              value={pageTitle}
                              onChange={(e) => setPageTitle(e.target.value)}
                            />
                          </div>
                        </div>
                        {showDuplicateErrorDialog && (
                          <Alert severity="error" sx={{ mb: 2 }}>
                            {duplicateErrorMessage || "A page with this title already exists or there was an error while duplicating the page."}
                          </Alert>
                        )}
                        <Box
                          component="div"
                          sx={{
                            p: 1,
                            borderRadius: 1,
                            backgroundColor: "#F7EEF9",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <InfoOutlinedIcon
                              style={{ marginRight: "8px" }}
                              color="secondary"
                            />
                            <Typography variant="h6" color="#9C27B0">
                              PLEASE NOTE:
                            </Typography>
                          </div>
                          <Typography color="#9C27B0" sx={{ paddingLeft: 5 }}>
                            All pages are duplicated with either a "Publish" or
                            "Draft" status.
                          </Typography>
                        </Box>
                      </div>
                      <DialogActions>
                        <Button
                          onClick={handleCloseDuplicateDialogBox}
                          color="secondary"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={() => validate()}
                          variant="contained"
                          color="secondary"
                          data-tracker="22"
                          disabled={duplicateLoading}
                          endIcon={duplicateLoading ? <CircularProgress size={20} color="inherit" /> : <AutoFixHighIcon />}
                        >
                          {duplicateLoading ? "Duplicating..." : "Duplicate"}
                        </Button>
                      </DialogActions>
                    </Dialog>
                    {/* Duplicate Error Dialog removed in favor of inline alert */}
                    <div className="button86">
                      <div className="base28">
                        <Tooltip title="Preview" placement="top">
                          <IconButton disabled={isEditing}>
                            {hasEditPageContentPermission ? (
                              <PreviewIcon
                                onClick={handleClickOpen}
                                data-tracker="19"
                                sx={{ cursor: "pointer" }}
                                color={isEditing ? "disabled" : "secondary"}
                              />
                            ) : (
                              <PreviewIcon color="disabled" data-tracker="19" />
                            )}
                          </IconButton>
                        </Tooltip>
                        {loading &&
                        (!previewCurrentChangesLink ||
                          previewCurrentChangesLink === "" ||
                          previewCurrentChangesLink === undefined) ? (
                          <div>
                            <SimpleBackdrop />
                          </div>
                        ) : pageContent?.theme_v2 !== null ? (
                          <Dialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                          >
                            <DialogTitle
                              sx={{ m: 0, p: 2 }}
                              id="customized-dialog-title"
                            >
                              Page Preview
                            </DialogTitle>
                            <div style={{ padding: "10px" }}>
                              <FormControl
                                component="fieldset"
                                disabled={pageContent?.theme_v2 === null}
                              >
                                <FormLabel component="legend">
                                  Version to Show
                                </FormLabel>
                                <RadioGroup
                                  row
                                  value={selectedVersion}
                                  onChange={handleVersionChange}
                                  style={{ margin: "15px" }}
                                >
                                  <FormControlLabel
                                    value="Version 1"
                                    disabled={pageContent?.theme_v2 === null}
                                    control={<Radio color="secondary" />}
                                    label="Version 1"
                                  />
                                  <FormControlLabel
                                    value="Version 2"
                                    disabled={pageContent?.theme_v2 === null}
                                    control={<Radio color="secondary" />}
                                    label="Version 2"
                                  />
                                </RadioGroup>
                              </FormControl>
                              {selectedVersion && (
                                <FormControl component="fieldset">
                                  <FormLabel component="legend">
                                    Additional Options
                                  </FormLabel>
                                  <RadioGroup
                                    row
                                    value={selectedVersion}
                                    onChange={handleDeviceChange}
                                  >
                                    <div style={{ margin: "15px" }}>
                                      <FormControlLabel
                                        value="1440px"
                                        control={<Radio color="secondary" />}
                                        data-tracker="20"
                                        label="Desktop (1440px)"
                                      />
                                      <FormControlLabel
                                        value="768px"
                                        control={<Radio color="secondary" />}
                                        data-tracker="20"
                                        label="Tablet (768px)"
                                      />
                                      <FormControlLabel
                                        value="360px"
                                        control={<Radio color="secondary" />}
                                        data-tracker="20"
                                        label="Mobile (360px)"
                                      />
                                    </div>
                                  </RadioGroup>
                                </FormControl>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  gap: "5px",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          </Dialog>
                        ) : (
                          <Dialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                          >
                            <DialogTitle
                              sx={{ m: 0, p: 2 }}
                              id="customized-dialog-title"
                            >
                              Page Preview
                            </DialogTitle>
                            <div style={{ padding: "10px" }}>
                              <FormControl
                                component="fieldset"
                                disabled={pageContent?.theme_v2 === null}
                              >
                                <FormLabel component="legend">
                                  Version to Show
                                </FormLabel>
                                <RadioGroup
                                  row
                                  value={selectedVersion}
                                  onChange={handleVersionChange}
                                  style={{ margin: "15px" }}
                                >
                                  <FormControlLabel
                                    value="Version 1"
                                    disabled={pageContent?.theme_v2 === null}
                                    control={<Radio color="secondary" />}
                                    label="Version 1"
                                  />
                                  <FormControlLabel
                                    value="Version 2"
                                    disabled={pageContent?.theme_v2 === null}
                                    control={<Radio color="secondary" />}
                                    label="Version 2"
                                  />
                                </RadioGroup>
                                <DialogContent>
                                  This option is only available when an A/B Test
                                  is running.
                                </DialogContent>
                              </FormControl>
                              <FormControl component="fieldset">
                                <FormLabel component="legend">
                                  Additional Options
                                </FormLabel>
                                <RadioGroup
                                  row
                                  value={selectedVersion}
                                  onChange={handleDeviceChange}
                                >
                                  <div style={{ margin: "15px" }}>
                                    <FormControlLabel
                                      value="1440px"
                                      control={<Radio color="secondary" />}
                                      data-tracker="20"
                                      label="Desktop (1440px)"
                                    />
                                    <FormControlLabel
                                      value="768px"
                                      control={<Radio color="secondary" />}
                                      data-tracker="20"
                                      label="Tablet (768px)"
                                    />
                                    <FormControlLabel
                                      value="360px"
                                      control={<Radio color="secondary" />}
                                      data-tracker="20"
                                      label="Mobile (360px)"
                                    />
                                  </div>
                                </RadioGroup>
                              </FormControl>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  gap: "5px",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          </Dialog>
                        )}
                      </div>
                    </div>
                    <div className="button86">
                      <div className="base28">
                        {hasEditPageContentPermission ? (
                          <Tooltip title="Save" placement="top">
                            {((postStatus === "draft" ||
                              postStatus === "publish" ||
                              postStatus === "pending") &&
                              isElementSaved === true) ||
                            postStatus === "draft" ||
                            postStatus === "publish" ? (
                              <IconButton>
                                <SaveIcon
                                  data-tracker="18"
                                  onClick={() => savePage()}
                                  color={"secondary"}
                                  // color="disabled"
                                  sx={{ cursor: "pointer" }}
                                />
                              </IconButton>
                            ) : (
                              <IconButton>
                                <SaveIcon
                                  data-tracker="18"
                                  sx={{ cursor: "pointer" }}
                                  color="disabled"
                                />
                              </IconButton>
                            )}
                          </Tooltip>
                        ) : (
                          <IconButton>
                            <SaveIcon sx={{ cursor: "pointer" }} />
                          </IconButton>
                        )}
                      </div>
                    </div>
                    {hasEditPageContentPermission ? (
                      <Button
                        disabled={
                          postStatus === "publish" && isElementSaved === false
                        }
                        sx={{ display: "flex", alignItems: "center" }}
                        size="small"
                        data-tracker="17"
                        variant="contained"
                        color="secondary"
                        onClick={() => publishPage()}
                      >
                        PUBLISH
                        <PublishIcon
                          sx={{
                            width: "18px",
                            marginLeft: "8px",
                            marginTop: "-3px",
                          }}
                        />
                      </Button>
                    ) : (
                      <Button
                        disabled
                        variant="contained"
                        size="small"
                        data-tracker="17"
                      >
                        PUBLISH
                        <PublishIcon
                          sx={{
                            width: "18px",
                            marginLeft: "8px",
                            marginTop: "-3px",
                          }}
                        />
                      </Button>
                    )}
                  </div>
                </div>
                <Grid container alignItems="center" px={2}>
                  <Grid item xs={10}>
                    <Grid container columnSpacing={2}>
                      <Grid item sx={{ width: "auto" }}>
                        <Stack direction="row" gap={1}>
                          <Typography fontWeight={500} color="text.primary">
                            Page Group:
                          </Typography>
                          <Typography fontWeight={400} color="text.primary">
                            {pageContent?.page_group_name}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item sx={{ width: "auto" }}>
                        <Stack direction="row" gap={1}>
                          <Typography fontWeight={500} color="text.primary">
                            Last Modified:
                          </Typography>
                          <Typography fontWeight={400} color="text.primary">
                            {pageContent?.post_date
                              ? formatDate(pageContent.post_date.split(" ")[0])
                              : ""}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item sx={{ width: "auto" }}>
                        <Stack direction="row" alignItems="center" gap={1}>
                          <Typography fontWeight={500} color="text.primary">
                            Modified By:
                          </Typography>
                          <Avatar
                            alt="Someone McSomething"
                            src="#"
                            sx={{ width: 24, height: 24 }}
                          />
                          <Typography fontWeight={400} color="text.primary">
                            {pageContent?.modified_by}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    {hasEditPagesMetaPermission ? (
                      <Button
                        color="secondary"
                        onClick={handleOpenModal}
                        data-tracker="28"
                        disabled={
                          pageContent?.post_status === "draft" ||
                          pageContent?.post_status === "pending"
                        }
                        disableRipple
                        sx={{
                          textDecoration: "underline",
                          padding: 0,
                          "&:hover": {
                            backgroundColor: "transparent", // Prevent background change
                            textDecoration: "underline", // Remove underline on hover
                          },
                        }}
                      >
                        EDIT PAGE META AND INFO
                      </Button>
                    ) : (
                      <Button
                        color="secondary"
                        disabled
                        disableRipple
                        data-tracker="28"
                        sx={{
                          textDecoration: "underline",
                          padding: 0,
                        }}
                      >
                        EDIT PAGE META AND INFO
                      </Button>
                    )}
                  </Grid>
                </Grid>
                <EditPageModal
                  openModal={openModal}
                  handleClose={handleCloseModal}
                  pageContent={pageContent}
                  setOpenModal={setopenModal}
                  setPageRefreshStatus={setPageRefreshStatus}
                  setPreview={() => {}}
                />
              </div>
            </div>
          </div>
          {previewCurrentChangesLink && iframeWidth !== 0 && (
            <Dialog
              sx={{ zIndex: "9999999" }}
              open={openDialog}
              maxWidth={"xl"}
            >
              <div style={{ position: "relative", overflowY: "hidden" }}>
                {loading && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <CircularProgress sx={{ color: "#9C27B0" }} />
                  </div>
                )}
                <div className="title-version">
                  <DialogTitle sx={{ padding: "0" }}>Page Preview</DialogTitle>
                  <CloseIcon
                    color="secondary"
                    onClick={handleClose}
                    sx={{ cursor: "pointer", float: "right" }}
                  />
                </div>
                {pageContent?.theme_v2 !== null ? (
                  <iframe
                    title="Page Preview"
                    src={
                      selectedVersion === "Version 1" // if version 1
                        ? iframeWidth === 768 //if tablet
                          ? `${previewCurrentChangesLink}&react_devices=tablet&v=1`
                          : iframeWidth === 414 // if mobile
                          ? `${previewCurrentChangesLink}&react_devices=mobile&v=1`
                          : `${previewCurrentChangesLink}&v=1` // if desktop
                        : selectedVersion === "Version 2" // if version 2
                        ? iframeWidth === 768 //if tablet
                          ? `${previewCurrentChangesLink}&react_devices=tablet&v=2`
                          : iframeWidth === 414 // if mobile
                          ? `${previewCurrentChangesLink}&react_devices=mobile&v=2`
                          : `${previewCurrentChangesLink}&v=2`
                        : `${previewCurrentChangesLink}&v=2`
                    }
                    style={{
                      maxWidth: "100%",
                      width: `${iframeWidth}px`,
                      height:
                        iframeWidth === 414
                          ? "600px"
                          : iframeWidth === 768
                          ? "550px"
                          : "600px",
                      background: "white",
                      padding: "16px 24px 24px 24px",
                    }}
                    onLoad={() => setLoading(false)}
                  ></iframe>
                ) : (
                  <iframe
                    title="Page Preview"
                    src={
                      iframeWidth === 768 //if tablet
                        ? `${previewCurrentChangesLink}&react_devices=tablet&v=1`
                        : iframeWidth === 414 // if mobile
                        ? `${previewCurrentChangesLink}&react_devices=mobile&v=1`
                        : `${previewCurrentChangesLink}&v=1`
                    } // if desktop
                    style={{
                      width: `${iframeWidth}px`,
                      height: iframeWidth === 414 ? "650px" : iframeHeight,
                      border: "1px solid #ccc",
                    }}
                    onLoad={() => setLoading(false)}
                  ></iframe>
                )}
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}
